import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { setUserActivity } from 'services/trackUserActivity';

const RouteTracker = () => {
    const location = useLocation();
    const { id } = useParams();

    const screenId = location.pathname
        .replace(/^\/dashboard\/?/, '')
        .split('/')
        .filter((item) => item !== id)
        .join('_')
        .replace(/-/g, '_');

    useEffect(() => {
        if (location.pathname.includes('/dashboard')) {
            setUserActivity({
                patientId: id ?? null,
                eventName: 'route_changed',
                eventDetails: {
                    screen: screenId,
                    route_pattern: location.pathname
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return null;
};

export default RouteTracker;
